import { createSlice } from '@reduxjs/toolkit';

const licenseSlice = createSlice({
  name: 'licenseGroup',
  initialState: {
    licenseGroup: [],
    pro: [],
    art: [],
    all: [],
    edu: undefined,
    free: undefined,
    organization: {}
  },
  reducers: {
    setLicenseGroup(state, action) {
      state[action.payload.key] = action.payload.value;
    },
    setPro(state, action) {
      state.pro = action.payload;
    },
    setArt(state, action) {
      state.art = action.payload;
    },
    setAll(state, action) {
      state.all = action.payload;
    },
    setEdu(state, action) {
      state.edu = action.payload;
    },
    setOrganization(state, action) {
      state.organization = action.payload;
    }
  },
});

export const {
  setLicenseGroup,
  setPro,
  setArt,
  setAll,
  setEdu,
  setOrganization,
} = licenseSlice.actions;

export default licenseSlice.reducer;
